<template>
  <transition
    name="el-zoom-in-top"
    @after-leave="doDestroy"
  >
    <div
      v-show="showPopper"
      class="el-autocomplete-suggestion el-popper"
      :style="{ width: dropdownWidth }"
      role="region"
    >
      <el-divider v-if="!$parent.$props.popperClass" />
      <el-scrollbar
        tag="ul"
        wrap-class="el-autocomplete-suggestion__wrap"
        view-class="el-autocomplete-suggestion__list"
      >
        <slot />
      </el-scrollbar>
    </div>
  </transition>
</template>
<script>
  import Popper from '@uikit/ui-kit/src/utils/vue-popper';
  import Emitter from '@uikit/ui-kit/src/mixins/emitter';
  import ElScrollbar from '@uikit/ui-kit/packages/scrollbar';
  import ElDivider from '@uikit/ui-kit/packages/divider';

  export default {
    components: {
      ElScrollbar,
      ElDivider
    },

    mixins: [Popper, Emitter],

    componentName: 'ElAutocompleteSuggestions',

    props: {
      popperOptions: {
        default() {
          return {
            flipBehavior: ['bottom'],
            gpuAcceleration: false,
            boundariesElement: 'scrollParent'
          };
        }
      },
      id: String,
      maxHeight: {
        type: Number,
        default: 336
      }
    },

    data() {
      return {
        parent: this.$parent,
        dropdownWidth: ''
      };
    },

    updated() {
      this.$nextTick(() => {
        this.updatePopper();
      });
    },

    mounted() {
      this.$parent.popperElm = this.$el;
      this.popperElm = this.$el;
      this.referenceElm = this.$parent.$refs.autocomplete;
      this.referenceList = this.$el.querySelector('.el-autocomplete-suggestion__list');
      this.referenceList.setAttribute('role', 'listbox');
      this.referenceList.setAttribute('id', this.id);
    },

    created() {
      this.$on('visible', (val) => {
        this.dropdownWidth = `${this.$parent.$refs.autocomplete.offsetWidth}px`;
        this.showPopper = val;
      });
    }
  };
</script>
